// features/branches/branchesSlice.ts (optional, if you want to store in Redux state)
import { createSlice } from '@reduxjs/toolkit';
import { fetchBranches, IBranch } from './frontGlobalsThunks';

interface BranchesState {
    branches: IBranch[];
    loading: boolean;
    error: string | null;
}

const initialState: BranchesState = {
    branches: [],
    loading: false,
    error: null,
};

const frontGlobalsSlice = createSlice({
    name: 'branches',
    initialState,
    reducers: {
        clearBranches: (state) => {
            state.branches = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBranches.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBranches.fulfilled, (state, action) => {
                state.loading = false;
                state.branches = action.payload;
            })
            .addCase(fetchBranches.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearBranches } = frontGlobalsSlice.actions;
export default frontGlobalsSlice.reducer;